import React from 'react';
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import MDEditor from '@uiw/react-md-editor';
import ModalShell from "../../../components/common/Modals/ModalShell";

const FirmwareDetailsModal: React.FC<ModalProps> = ({open, setOpen,object}) => {
  const firmware = object;

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size="lg"
      title={<span style={{textTransform:'capitalize'}}>{firmware?.type}</span>}
      subtitle={
        <span style={{display:'inline-flex', alignItems:'center', gap:'0.5rem'}}>
          Version {firmware?.version}
          {!!firmware?.is_latest && <span className="dlg-tag">LATEST</span>}
        </span>
      }
      actions={<button className="btn btn-primary" onClick={handleClose}>Close</button>}
    >
      <div className="markdown-body" data-color-mode={localStorage.getItem('data-theme') ?? (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')}>
        <MDEditor.Markdown source={firmware?.description} className="markdown-preview" />
      </div>
    </ModalShell>
  )};

export default FirmwareDetailsModal;
